"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentModelParameterDefinitionSchema = exports.ComponentModelParameterDefinitionMapSchema = void 0;
const zod_1 = require("zod");
const BoundaryClass_1 = require("./DesignModels/BoundaryClass");
exports.ComponentModelParameterDefinitionMapSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.lazy(() => exports.ComponentModelParameterDefinitionSchema));
exports.ComponentModelParameterDefinitionSchema = zod_1.z.object({
    name: zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.symbol()]),
    description: zod_1.z.string().optional(),
    classes: BoundaryClass_1.BoundaryClassSchema.array().optional(),
    otherNames: zod_1.z.string().array().optional(),
    type: zod_1.z.enum(['string', 'number', 'object']),
    required: zod_1.z.boolean(),
    isValueParameter: zod_1.z.boolean().optional(),
    defaultValue: zod_1.z.any().optional(),
    defaultVariance: zod_1.z.string().optional(),
    units: zod_1.z
        .object({
        short: zod_1.z.string(),
        long: zod_1.z.string(),
        alternateNames: zod_1.z.string().array().optional(),
        usesSIPrefixes: zod_1.z.boolean().optional(),
    })
        .optional(),
});
//# sourceMappingURL=ComponentModelParameterDefinition.js.map